"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.04 5.685c.376.419.7.866.964 1.293.264-.424.59-.871.968-1.29.918-1.02 2.142-1.879 3.534-1.872C19.204 3.83 21 5.448 21 9.098c0 4.386-6.38 9.411-8.394 10.889a1.01 1.01 0 0 1-1.202-.003C9.39 18.494 3 13.422 3 9.098 3 5.82 4.796 3.816 7.5 3.816c1.405 0 2.626.852 3.54 1.869Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HeartFilledIcon24.js.map